import type {ForestMassRepository} from '@/domain/interfaces/ForestMassRepository';

export class GetForestMassByUuidUseCase {
  constructor(private readonly repository: ForestMassRepository) {}
  async execute(uuid: string) {
    return this.repository.getById(uuid);
  }
}
